import { useEffect, useState } from 'react';
import { fetchNode } from '~api/DrupalAPI/DrupalAPI';

export const useDrupalNodes = (nodeIds: string[], language: string) => {
    const [nodeHTML, setNodeHTML] = useState('');
    const [fetched, setFetched] = useState(false);
    const isValidNodeId = nodeIds.some((nodeId) => nodeId && nodeId !== '0');

    const fetchNodeData = async () => setNodeHTML(await fetchNode(nodeIds, language.toLowerCase()));

    useEffect(() => {
        if (!fetched && isValidNodeId) {
            fetchNodeData()
                .catch(console.error)
                .finally(() => setFetched(true));
        }
    }, [nodeIds]);

    return { nodeHTML, isValidNodeId };
};
